(() => {
  const script = document.currentScript;
  const language = (script?.dataset.language || document.documentElement.lang).split('-')[0];
  if (!['ro', 'hu'].includes(language)) return;
  const searchPath = script?.dataset.searchUrl || '/search';
  const opposite = language === 'ro' ? 'hu' : 'ro';
  const suffix = ' -tag:ggpix-design-' + opposite;
  const cleanTerms = (value) => {
    let text = String(value || '').replace(/\s+-tag:ggpix-design-(ro|hu)\s*$/i, '').trim();
    if (text.startsWith('( ') && text.endsWith(' )')) text = text.slice(2, -2);
    return text.trim();
  };
  const scopedTerms = (value) => cleanTerms(value);
  const normalize = (input) => {
    const url = new URL(input, location.origin);
    if (url.origin !== location.origin) return url;
    const match = url.pathname.match(/^(.*\/collections\/)([^/]+)(?:\/([^/]+))?\/?$/);
    if (match) {
      const name = match[2];
      if (['vendors', 'types'].includes(name)) {
        const value = url.searchParams.get('q');
        if (!value) return url;
        url.pathname = searchPath;
        url.searchParams.set('q', scopedTerms((name === 'vendors' ? 'vendor:' : 'product_type:') + JSON.stringify(value)));
        url.searchParams.set('type', 'product');
      } else {
        const tags = (match[3] || '').split('+').filter(Boolean).filter(tag => !['ggpix-ro', 'ggpix-hu'].includes(decodeURIComponent(tag)));
        tags.push('ggpix-' + language);
        const path = match[1] + name + '/' + tags.join('+');
        if (path !== url.pathname) {
          url.pathname = path;
          url.searchParams.delete('page');
        }
      }
    } else if (url.pathname.replace(/\/$/, '') === searchPath.replace(/\/$/, '') && url.searchParams.has('q')) {
      const scoped = scopedTerms(url.searchParams.get('q'));
      if (scoped && scoped !== url.searchParams.get('q')) {
        url.searchParams.set('q', scoped);
        url.searchParams.delete('page');
      }
    }
    return url;
  };
  window.GGPixCatalog = { cleanTerms, scopedTerms, normalize };
  const current = normalize(location.href);
  if (current.href !== location.href) {
    location.replace(current.href);
    return;
  }
  document.querySelectorAll('input[type="search"][name="q"]').forEach(input => {
    input.value = cleanTerms(input.value);
  });
  document.addEventListener('click', event => {
    const anchor = event.target.closest?.('a[href]');
    if (!anchor || anchor.hasAttribute('download')) return;
    const destination = normalize(anchor.href);
    if (destination.href !== anchor.href) anchor.href = destination.href;
  }, true);
  document.addEventListener('formdata', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, location.origin);
    if (action.origin !== location.origin || action.pathname.replace(/\/$/, '') !== searchPath.replace(/\/$/, '')) return;
    if (event.formData.has('q')) event.formData.set('q', scopedTerms(event.formData.get('q')));
  });
})();
